import { createContext } from "react";
import { IThemeContext } from "./type.d";
import { DefaultThemeWeb } from "../../themes/DefaultThemeWeb";

export default createContext<IThemeContext>({ type: 'default', changeTheme: (client: String) => { }, theme:DefaultThemeWeb })
